import oauth from '@utils/OAuth2'
import rights from '@utils/RightManager'

interface Props {
  i18n: I18n
  current: string
  navigation: Navigation
  openAccount: () => void
}

const canGoToPilotage = () => true
const canGoToInformation = () => true

const useMenuElements = ({ i18n, current, navigation, openAccount }: Props): MenuElement[] =>
  [
    canGoToPilotage() && {
      title: i18n.t('components.globalmenu.pilotage.title'),
      status: 'active',
      type: 'action',
      size: 'medium',
      childrens: [
        canGoToPilotage() && {
          title: i18n.t('components.globalmenu.pilotage.region'),
          status: current === '/pilotage' ? 'disabled' : 'active',
          type: 'action',
          size: 'medium',
          onclick: () => navigation.push('/monitor/region'),
        },
      ],
      img: require('./assets/pilotage.jpeg').default,
    },
    {
      title: i18n.t('components.globalmenu.map.title'),
      status: current === '/' ? 'disabled' : 'active',
      type: 'action',
      size: 'medium',
      onclick: () => navigation.push('/'),
      childrens: [],
      img: require('./assets/map.jpeg').default,
    },
    (rights.canAdminExtUsers() ||
      rights.canAdminExtUsers() ||
      rights.canAdminCompany() ||
      rights.canAffectCompanyOnBusiness() ||
      rights.canSeeData()) && {
      title: i18n.t('components.globalmenu.admin.title'),
      status: 'active',
      type: 'action',
      size: 'medium',
      childrens: [
        rights.canAdminIntUsers() && {
          title: i18n.t('components.globalmenu.admin.internals'),
          status: current === '/admin/internals' ? 'disabled' : 'active',
          type: 'action',
          size: 'medium',
          onclick: () => navigation.push('/admin/internals'),
        },
        rights.canAdminExtUsers() && {
          title: i18n.t('components.globalmenu.admin.externals'),
          status: current === '/admin/externals' ? 'disabled' : 'active',
          type: 'action',
          size: 'medium',
          onclick: () => navigation.push('/admin/externals'),
        },
        rights.canAdminCompany() && {
          title: i18n.t('components.globalmenu.admin.companies'),
          status: current === '/admin/companies' ? 'disabled' : 'active',
          type: 'action',
          size: 'medium',
          onclick: () => navigation.push('/admin/companies'),
        },
        rights.canAffectCompanyOnBusiness() && {
          title: i18n.t('components.globalmenu.admin.businesses'),
          status: current === '/admin/businesses' ? 'disabled' : 'active',
          type: 'action',
          size: 'medium',
          onclick: () => navigation.push('/admin/businesses'),
        },
        rights.canSeeData() && {
          title: i18n.t('components.globalmenu.admin.datas'),
          status: current === '/admin/data' ? 'disabled' : 'active',
          type: 'action',
          size: 'medium',
          onclick: () => navigation.push('/admin/data'),
        },
      ],
      img: require('./assets/admin.jpeg').default,
    },
    canGoToInformation() && {
      title: i18n.t('components.globalmenu.process.title'),
      status: 'active',
      type: 'action',
      size: 'medium',
      childrens: [],
      img: require('./assets/process.jpeg').default,
      onclick: () => {
        navigation.push('/information')
      },
    },
    {
      title: i18n.t('components.globalmenu.profile.title'),
      status: 'active',
      type: 'action',
      size: 'medium',
      childrens: [
        {
          title: i18n.t('components.globalmenu.profile.account'),
          status: 'active',
          type: 'action',
          size: 'medium',
          childrens: [],
          img: require('./assets/logout.jpeg').default,
          onclick: openAccount,
        },
        {
          title: i18n.t('components.globalmenu.profile.logout'),
          status: 'active',
          type: 'action',
          size: 'medium',
          childrens: [],
          img: require('./assets/logout.jpeg').default,
          onclick: oauth.logout,
        },
      ],
      img: require('./assets/logout.jpeg').default,
    },
  ].filter(Boolean) as MenuElement[]

export default useMenuElements
